export const isExpanded = (element) => element?.getAttribute('aria-expanded') === 'true';

export const setExpanded = (element, value) => {
  if (element) {
    element.setAttribute('aria-expanded', value ? 'true' : 'false');
  }
};

export const setAccordionState = (item, isActive) => {
  if (!item) return;
  item.classList.toggle('accordion-item-active', isActive);
  const button = item.querySelector('.accordion-trigger');
  if (button) {
    button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  }
};
